export class DeviceUtil {
  /**
   * Detects mobile/tablet devices, including iPadOS in "Desktop Mode".
   * Returns `false` for touch-enabled laptops (Windows) and standard MacBooks and normal PC.
   */
  static isMobileOrTablet = (): boolean => {
    // SSR Guard
    if (typeof window === 'undefined' || typeof navigator === 'undefined') {
      return false;
    }

    const { userAgent, platform, maxTouchPoints } = navigator;

    const MOBILE_REGEX = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
    // Standard check: Excludes 'Windows' to safely ignore touch-enabled laptops
    const isStandardMobile = MOBILE_REGEX.test(userAgent);

    // iPadOS 13+ check: Identifies iPads spoofing as 'MacIntel' via touch points
    const isIpadDesktopMode =
      platform === 'MacIntel' &&
      maxTouchPoints >= 5 && // iPads have 5+ points, prevent block for old MacBook pro that have touch bar ( 0-2 points )
      /Safari/.test(userAgent);

    return isStandardMobile || isIpadDesktopMode;
  };
}
